import { Component } from '@angular/core';

@Component({
  selector: 'app-ubicacion',
  imports: [],
  templateUrl: './ubicacion.html',
  styleUrl: './ubicacion.scss'
})
export class Ubicacion {

}
